import React from 'react';
import Heading from '../../../generic-components/Heading';

interface IProps {
    name: string;
    email?: string;
}
export const VendorInfo = ({ name, email }: IProps) => (
  <div className='flex flex-col text-left'>
    <Heading title={name} className='font-metricRMedium text-[14px] text-bw08' />
    {email && <Heading title={email} className='font-metricR text-[14px] text-bw06' />}
  </div>
);
